import * as v from "valibot";
import { BaseRecordSchema, baseVals, defineValidation } from "../../common/validation.common";

export namespace AssociateUserValidation {
    export const Record = defineValidation(BaseRecordSchema);

    export const Create = defineValidation(
        v.object({
            name: baseVals.string(),
            phone: baseVals.phone(),
            address: baseVals.string(),
            refcode: baseVals.string(),
            email: v.optional(baseVals.email()),
            username: baseVals.username(),
            password: baseVals.password(),
            position: v.optional(baseVals.string()),
            privileges: v.array(v.string()),
        }),
    );

    export const Update = defineValidation(
        v.object({
            name: v.exactOptional(baseVals.string()),
            phone: v.exactOptional(baseVals.phone()),
            address: v.exactOptional(baseVals.string()),
            refcode: v.exactOptional(baseVals.string()),
            email: v.exactOptional(baseVals.email()),
            username: v.exactOptional(baseVals.username()),
            password: v.exactOptional(baseVals.password()),
            position: v.exactOptional(baseVals.string()),
            privileges: v.exactOptional(v.array(v.string())),
        }),
    );

    export namespace API {
        export const Update = defineValidation(
            v.object({
                name: v.exactOptional(baseVals.string()),
                phone: v.exactOptional(baseVals.phone()),
                address: v.exactOptional(baseVals.string()),
            }),
        );
    }
}
